// useBottomNavHeight.ts
import { useMemo } from 'react';
import { requiresBottomSafeArea, useUserAgent } from '~/core/util/device';

export const useBottomNavHeight = () => {
  const userAgent = useUserAgent();
  const bottomNavHeight = useMemo(() => {
    if (requiresBottomSafeArea(userAgent)) {
      return '80px';
    }
    return 'calc(env(safe-area-inset-bottom) + 56px)';
  }, [userAgent]);

  return bottomNavHeight;
};
